module.exports = __webpack_public_path__ + "static/sponsorship_img-05-c@2x-77d57abff86c4274bcca8a3247b10fc8.jpg";